/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'ai-mate.all-chat-view.chat-item.chat-options-button-label': '{conversationName} のチャット オプション',
  'ai-mate.all-chat-view.chat-item.delete-label': '削除',
  'ai-mate.all-chat-view.chat-item.rename-label': '名前を変更',
  'ai-mate.all-chat-view.new-chat-button-label': '新規チャット',
  'ai-mate.chat-error-banner.description': 'チャット履歴は最大 30 日間保存されます。',
  'ai-mate.chat-error-banner.title': '新規チャットを開始',
  'ai-mate.chat-error.description': '<btn>チャットの再読み込み</btn>をお試しください。',
  'ai-mate.chat-error.rate-limited-description':
    'リクエスト数の上限に達しました。しばらくしてからもう一度お試しください。',
  'ai-mate.chat-error.rate-limited-title': 'リクエストが多すぎます',
  'ai-mate.chat-error.rovo-inactive-description':
    'サイトで Rovo が有効になっていないようです。<link>Rovo のセットアップについてご確認ください。</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo は非アクティブです',
  'ai-mate.chat-error.title': '原因不明のエラーが発生しました',
  'ai-mate.chat-history.loading-state.collapse-icon': '折りたたむ',
  'ai-mate.chat-history.loading-state.expand-icon': '展開',
  'ai-mate.chat-history.loading-state.rovo-is-thinking': 'Rovo が考え中',
  'ai-mate.chat-input.file-close-icon-label': 'ファイルを削除',
  'ai-mate.chat-input.file-error-icon-label': 'ファイルの読み込み中にエラーが発生しました',
  'ai-mate.chat-input.store-user-messages.label': '回答の質を高めるためにこのメッセージを記録する',
  'ai-mate.chat-view.chat-item.chat-delete-label': '削除',
  'ai-mate.chat-view.chat-item.chat-options-for-conversation-button-label': '{conversationName} のチャット オプション',
  'ai-mate.chat-view.chat-item.chat-rename-label': '名前を変更',
  'ai-mate.common.ui.expandable-section.collapse': '折りたたむ',
  'ai-mate.common.ui.expandable-section.expand': '展開',
  'ai-mate.conversation-assistant-page-selector.page-selector-label': 'ページを選択',
  'ai-mate.conversation-assistant-space-selector.space-selector-label': 'スペースの選択',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.cancel-button-label.non-final': 'キャンセル',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.conversation-not-found-failure-message.non-final':
    '削除しようとしている会話は存在しません。',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-button-label.non-final': '削除',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-conversation-title.non-final':
    '会話 "{name}" を削除しますか?',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.generic-failure-message.non-final':
    '会話の削除中にエラーが発生しました。もう一度お試しください。',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.modal-body.non-final':
    'この会話を削除してもよろしいですか? この操作は元に戻せません。',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final': 'キャンセル',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final':
    '編集しようとしているチャンネルは存在しません。',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final': '名前',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final':
    '会話の編集中にエラーが発生しました。もう一度お試しください。',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final': '会話の編集',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final':
    '名前が現在の名前と同じです。',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final': '保存',
  'ai-mate.conversation-list-view.accessible-search-results':
    '{results, plural, other {{results,number} 件の検索結果が見つかりました}}',
  'ai-mate.conversation-list-view.back-button.label': '戻る',
  'ai-mate.conversation-list-view.close-chat-button.label': 'チャットを閉じる',
  'ai-mate.conversation-list-view.header-title': 'チャット履歴',
  'ai-mate.conversation-list-view.new-chat-button.label': '新規チャット',
  'ai-mate.conversation-list-view.no-chat': '該当する結果がありません',
  'ai-mate.conversation-list-view.search-input.placeholder': 'チャットを検索',
  'ai-mate.date-time-utils.time.now': 'たった今',
  'ai-mate.date-time-utils.time.yesterday': '昨日',
  'ai-mate.expander.hide-details': '詳細を非表示',
  'ai-mate.expander.show-details': '詳細をさらに表示',
  'ai-mate.loading-status-indicator.discovery': 'ディスカバリー',
  'ai-mate.loading-status-indicator.error': 'エラー',
  'ai-mate.loading-status-indicator.info': '情報',
  'ai-mate.loading-status-indicator.loading': '読み込み中',
  'ai-mate.loading-status-indicator.success': '成功',
  'ai-mate.loading-status-indicator.todo': '未着手',
  'ai-mate.loading-status-indicator.warning': '警告',
  'ai-mate.main-chat.close-chat-panel-button-label': 'チャットを閉じる',
  'ai-mate.main-chat.hamburger-menu-label': 'メニュー',
  'ai-mate.main-chat.maximize-chat-button-label': '全画面表示',
  'ai-mate.main-chat.minimize-chat-button-label': 'ビューを復元',
  'ai-mate.main-chat.new-chat-button-label': '新規',
  'ai-mate.main-chat.new-chat-button-label-full-screen': '新規チャット',
  'ai-mate.rovo-chat-header.back-home-button-label': 'ホームに戻る',
  'ai-mate.rovo-chat-header.chrome-extension-button-text': 'Chrome 拡張機能',
  'ai-mate.rovo-chat-header.chrome-extension-icon-label': 'Chrome 拡張機能',
  'ai-mate.rovo-chat-header.close-chat-header-button-label': '閉じる',
  'ai-mate.rovo-chat-header.debug-button-label': 'デバッグ',
  'ai-mate.rovo-chat-header.debug-icon-label': 'デバッグ',
  'ai-mate.rovo-chat-header.delete-button-text': '削除',
  'ai-mate.rovo-chat-header.delete-icon-label': '削除',
  'ai-mate.rovo-chat-header.feedback-button-text': 'フィードバック',
  'ai-mate.rovo-chat-header.feedback-icon-label': 'フィードバック',
  'ai-mate.rovo-chat-header.floating-button-text': 'フローティング',
  'ai-mate.rovo-chat-header.floating-icon-label': 'フローティング',
  'ai-mate.rovo-chat-header.fullscreen-button-text': '全画面表示',
  'ai-mate.rovo-chat-header.fullscreen-icon-label': '全画面表示',
  'ai-mate.rovo-chat-header.get-help-button-text': 'ヘルプ',
  'ai-mate.rovo-chat-header.get-help-icon-label': 'ヘルプ',
  'ai-mate.rovo-chat-header.menu-button-label': 'メニュー',
  'ai-mate.rovo-chat-header.more-menu-button-label': 'さらに表示',
  'ai-mate.rovo-chat-header.new-agent-chat-button-label': '{agentName} との新しいチャット',
  'ai-mate.rovo-chat-header.new-chat-button-label': '新規チャット',
  'ai-mate.rovo-chat-header.rename-button-text': '名前を変更',
  'ai-mate.rovo-chat-header.rename-icon-label': '名前を変更',
  'ai-mate.rovo-chat-header.sidebar-button-text': 'サイド バー',
  'ai-mate.rovo-chat-header.sidebar-icon-label': 'サイド バー',
  'ai-mate.rovo-chat-header.switch-mode-button-label': '切り替え先',
  'ai-mate.rovo-chat-header.switch-mode-section-text': '切り替え先',
  'conversation-assistant-button.ask-rovo-label': 'Rovo に質問する',
  'conversation-assistant-message-actions.require-information-tool.project-selector.header': 'プロジェクトを選択',
  'highlight-actions.rovo-chat-custom-prompt-submit-button.text': '送信',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'これについて AI に質問',
  'highlight-actions.rovo-chat-explain-option.text': '説明',
  'highlight-actions.rovo-chat-explain-prompt':
    '別の表現に言い換えたり、細かな情報を付け加えたりしてこの記述を説明してください。ただし、わかりやすい言葉を使用し、文は短くしてください。元の記述で専門用語が使われている場合は、その例や定義を示してください。',
  'highlight-actions.rovo-chat-find-resources-option.text': 'リソースを探す',
  'highlight-actions.rovo-chat-find-resources-prompt':
    '組織のナレッジの中からこの記述を裏付けるリソースを探してください。',
  'highlight-actions.rovo-chat-give-examples-option.text': '例を示す',
  'highlight-actions.rovo-chat-give-examples-prompt':
    '組織のリソースや公開されたナレッジから、この記述の例を挙げてください。該当する情報がない場合は、理解の手助けとなるような仮定の例を示してください。',
  'highlight-actions.rovo-chat-give-feedback-option.text': 'フィードバックを送信',
  'highlight-actions.rovo-chat-give-feedback-prompt':
    'この記述の表現をチェックしてフィードバックをください。単語の選択、文法、句読点の用法についてコメントしてください。ポジティブで建設的なトーンを保ちつつ、必ず少なくとも 1 つは改善点または変更点を提案してください。',
  'highlight-actions.rovo-chat-more-options.tooltip': 'チャットの推奨事項',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'チャットを開く',
  'highlight-actions.rovo-chat-summarize-option.text': '要約',
  'highlight-actions.rovo-chat-summarize-prompt':
    'この記述の要点を強調してください。重要な情報に注目し、不要な詳細は除外します。1 つのパラグラフで要旨を簡潔にまとめてください。',
  'highlight-actions.rovo-chat.ask-in-chat-button-text': 'チャットで質問',
  'highlight-actions.rovo-chat.ask-rovo-button-text': 'Rovo に質問する',
  'highlight-actions.rovo-chat.placeholder-prompt': 'これについて質問しましょう。',
  'horizontal-scroll-container.scroll-left': '左にスクロール',
  'horizontal-scroll-container.scroll-right': '右にスクロール',
  'rovo-chat.deep-research-spotlight.description':
    '詳細調査をオンにしてプロンプトを入力してください。Rovo がプランを作成し、調査を実施して、完全なレポートを作成します。',
  'rovo-chat.deep-research-spotlight.dismiss': '閉じる',
  'rovo-chat.deep-research-spotlight.heading': 'Rovo の詳細調査のご紹介',
  'rovo-chat.file-upload-dropzone.drag-drop-message': 'ドラッグ アンド ドロップでコンテキストを追加してください',
  'rovo-chat.message-file.icon-label': 'ファイル',
  'rovo-chat.rovo-greeting.deep-research-greeting-text': '詳しく調べてみましょう',
  'rovo-chat.rovo-greeting.default-greeting-text': '{name} さん、どのようなサポートをご希望ですか?',
  'rovo-chat.search-input.screen-reader-prompt': 'このフィールドに任意の文字を入力すると、下の検索結果が更新されます',
};
